import React, { useState } from "react";
import { useEffect } from "react";
import { memo } from "react";

const SorterNotes = ({ onSort, t }) => {
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("ascending");

  useEffect(() => {
    onSort(sortColumn, sortOrder);
  }, [sortColumn, sortOrder, onSort]);

  const handleSort = (column) => {
    let newSortOrder = "ascending";

    if (sortColumn === column) {
      // If the same column is clicked again, reverse the sort order
      if (sortOrder === "descending" && column === sortColumn) {
        setSortColumn(null);
      } else {
        newSortOrder = sortOrder === "ascending" ? "descending" : "ascending";
        setSortColumn(column);
      }
    } else {
      setSortColumn(column);
    }
    setSortOrder(newSortOrder);
  };

  return (
    <div className="bg-[#FAE094] border-[#A09F9F] border-b flex flex-row font-[600] h-[58px] leading-[21.79px] px-[40px] text-[16px] top-0 w-full z-10">
      <div className="flex flex-row gap-[10px] items-center w-[40px]">
        <button
          type="button"
          className="flex items-center sort-date"
          onClick={() => handleSort("isImportant")}
        >
          {" "}
          <p style={{ fontSize: 20, color: "red" }}>!</p>{" "}
          {sortColumn === "isImportant" && (
            <span style={{ marginLeft: 5 }}>
              {sortOrder === "ascending" ? "▲" : "▼"}
            </span>
          )}
        </button>
      </div>
      <div className="flex flex-row gap-[10px] items-center w-[145px]">
        <button
          type="button"
          className="flex items-center sort-date"
          onClick={() => handleSort("createDate")}
        >
          <p>{t("DateTime")}</p>{" "}
          {sortColumn === "createDate" && (
            <span>{sortOrder === "ascending" ? "▲" : "▼"}</span>
          )}
        </button>
      </div>
      <div className="flex items-center w-[250px]">
        <button
          type="button"
          className="flex items-center sort-date"
          onClick={() => handleSort("userName")}
        >
          {t("sentBy")}
          {sortColumn === "userName" && (
            <span>{sortOrder === "ascending" ? "▲" : "▼"}</span>
          )}
        </button>
      </div>
      <div className="flex items-center w-[620px]"> {t("notes")} </div>
      <div className="w-[113px]"></div>
    </div>
  );
};

export default memo(SorterNotes);
// onClick={() => handleSort('column1')}>
//             Column 1{' '}
//             {sortColumn === 'column1' && (
//               <span>{sortOrder === 'ascending' ? '▲' : '▼'}</span>
//             )}
//           </th>
